const useGetChallengeTimeLeft = (minutesLeft) => {
  let percentageDayPassed = ((1440 - minutesLeft) / 1440) * 100;

  return [Math.floor(minutesLeft / 60), 100 - percentageDayPassed];
};

export default useGetChallengeTimeLeft;
